import AsyncStorage from "@react-native-async-storage/async-storage";

const MATH_MODE_KEY = "math_mode_enabled";

export const saveMathModePreference = async (enabled: boolean) => {
  try {
    await AsyncStorage.setItem(MATH_MODE_KEY, JSON.stringify(enabled));
  } catch (error) {
    console.error("Error saving math mode preference:", error);
  }
};

export const getMathModePreference = async (): Promise<boolean> => {
  try {
    const value = await AsyncStorage.getItem(MATH_MODE_KEY);
    return value === "true";
  } catch (error) {
    console.error("Error getting math mode preference:", error);
    return false;
  }
};
